var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VApp',{staticClass:"main-ctn"},[_c('Header'),_c('VContent',{attrs:{"role":"main"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('RouterView')],1)],1),_c('Footer',{attrs:{"links":_vm.$t('components.footer.links')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }